import { render, staticRenderFns } from "./tinkAdmin.vue?vue&type=template&id=4b5a44ee"
import script from "./tinkAdmin.vue?vue&type=script&lang=js"
export * from "./tinkAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports